/* global Lang */

import React, { useMemo } from 'react';
import Card, { CardBody } from '../Card';

export default ({ time }) => {
  const readableTime = useMemo(() => {
    let minutes = time / 60;
    const hours = Math.floor(minutes / 60);
    minutes = Math.floor(minutes % 60);
    return Lang.get('messages.dashboard.formattedGameTime', { hours, minutes });
  }, [time]);

  return (
    <Card>
      <CardBody className="d-flex flex-row align-items-center">
        <strong className="mr-2">{Lang.get('messages.dashboard.gameTime')}</strong>
        <span className="ml-auto">{readableTime}</span>
      </CardBody>
    </Card>
  );
};
